// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h9DSg4RfW5uLfxRbogGR{background-color:#fff;margin-top:20px;min-height:50px;padding-left:20px !important}`, "",{"version":3,"sources":["webpack://./src/pages/admin/adminservices/AdminServicesForm.scss"],"names":[],"mappings":"AAGA,sBACE,qBAAA,CACA,eAAA,CACA,eAAA,CACA,4BAAA","sourcesContent":["@use \"../../../css/global\";\n\n\n.container {\n  background-color: white;\n  margin-top: 20px;\n  min-height: 50px;\n  padding-left: 20px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `h9DSg4RfW5uLfxRbogGR`
};
export default ___CSS_LOADER_EXPORT___;
